export default {
	//保存页面提示信息记录
	saveActionLog(log_pageAction, axios) {
		if (log_pageAction.userID) {
			log_pageAction.userID = log_pageAction.userID.id
		}
		//不包含成功 保存记录
		if(log_pageAction.message)
		{
			if (log_pageAction.message.indexOf('成功') == -1) {
				axios.post('api/Tool/SaveLog_PageActions', log_pageAction).then(res => {
					// console.log(res.data)
				})
			}
		}
	}
}
